import classes from "./SubmitSuccessLink.module.css";
export default function SubmitSuccessLink() {

  let externalReview = JSON.parse(localStorage.getItem("externalReview"));
  console.log(externalReview);
  if (externalReview === null) {
    externalReview = {
      link: "https://www.google.com",
      platform: "Google",
      message: "Please leave us a review on Google!",
    };
  }

  let link = externalReview.link;
  let message = externalReview.message;
  let checkString = link.substring(0, 3);
  if (checkString !== "htt") link = `https://${link}`;
  
  function clickHandler() {
    window.location.href = link;
  }
  return (
    <>
      <div className={classes.container}>
        <div className={classes.content}>
         <p>{message}</p>
         
          <button onClick={clickHandler}>Next</button>
        </div>
      </div>

      <div className={classes.linkPreview}>{link}</div>
    </>
  );
}
